export default __webpack_public_path__ + "static/media/green-blue-pattern.3b800e28.svg";